// eslint-disable-next-line custom-rules/no-react-router-dom-uselocation
import { useLocation as useReactLocation } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useLocation<T = any>() {
    const { state, pathname } = useReactLocation();

    return { state: state as T | undefined, pathname };
}
